import angular from 'angular';
import _ from 'lodash';

import maskedPasscodeDirective from './maskedPasscode.directive';

export default angular.module('fp:customerportal:common:maskedPasscode', [])
    .constant('_', _)
    .constant('Modernizr', Modernizr)
    .directive('fpMaskedPasscode', maskedPasscodeDirective);